import { render } from "./SecuritySet.vue?vue&type=template&id=49f0d775&scoped=true&ts=true"
import script from "./SecuritySet.vue?vue&type=script&lang=ts"
export * from "./SecuritySet.vue?vue&type=script&lang=ts"

import "./SecuritySet.vue?vue&type=style&index=0&id=49f0d775&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49f0d775"]])

export default __exports__